import React, { useState } from 'react';

interface SearchBoxProps {
  placeholder?: string;
  initialQuery?: string;
  autoFocus?: boolean;
  size?: 'small' | 'medium' | 'large';
  onSearch?: (query: string) => void;
  showGoogleSearch?: boolean;
  style?: React.CSSProperties;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder = "Search across all Epstein documents...",
  initialQuery = "",
  autoFocus = false,
  size = 'medium',
  onSearch,
  style
}) => {
  const [query, setQuery] = useState(initialQuery);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedQuery = query.trim();
    
    if (!trimmedQuery) return;

    if (onSearch) {
      onSearch(trimmedQuery);
    } else {
      // Get current domain from window.location
      const currentDomain = window.location.hostname;
      const siteQuery = `site:${currentDomain} ${trimmedQuery}`;
      const googleSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(siteQuery)}`;
      
      // Open Google search in new tab
      window.open(googleSearchUrl, '_blank');
    }
  };

  const sizeClasses = {
    small: 'search-box-small',
    medium: 'search-box-medium', 
    large: 'search-box-large'
  };

  return (
    <form onSubmit={handleSubmit} className={`search-box ${sizeClasses[size]}`} style={style}>
      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            className="search-input"
            autoFocus={autoFocus}
            autoComplete="off"
            spellCheck="false"
          />
        </div>
        <button type="submit" className="btn search-btn" disabled={!query.trim()}>
          Search
        </button>
      </div>
      
    </form>
  );
};

export default SearchBox;